import React from 'react';
import ReactDOM from 'react-dom';

import { HashRouter } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';

import router from './router';
import './i18n';

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      {renderRoutes(router)}
    </HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

